<template>
  <v-row justify="center">
    <v-dialog v-model="show" persistent max-width="600px">
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title>
            <span class="headl">EDITAR TIENDA</span>
          </v-card-title>
          <v-tabs v-model="tab" background-color="primary" dark>
            <v-tab :key="1">GENERAL</v-tab>
            <v-tab :key="2">PASARELA DE PAGO</v-tab>
            <v-tab :key="3">TRASPORTE</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tab">
            <v-tab-item :key="1">
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field
                        ref="name_shop"
                        v-model="datos.name_shop"
                        :rules="nameRules"
                        label="Nombre de la tienda"
                        required
                        disabled
                      ></v-text-field>
                      <v-text-field
                        ref="address"
                        v-model="datos.address"
                        :rules="inputRules"
                        label="Dirección fisica de su tienda"
                        required
                      ></v-text-field>

                      <v-text-field
                        ref="numContact"
                        v-model="datos.numContact"
                        :rules="inputRules"
                        label="Numero de contacto"
                        required
                      ></v-text-field>
                      <v-text-field
                        ref="instagram"
                        v-model="datos.instagram"
                        :rules="inputRules"
                        label="Instagram"
                        required
                      ></v-text-field>
                      <v-text-field
                        ref="face"
                        v-model="datos.face"
                        :rules="inputRules"
                        label="Facebook"
                        required
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <div v-if="datos.imgShop" class="preview_img">
                        <img
                          class="1"
                          :src="urlBaseApi.urlAssets + datos.imgShop.filename"
                        />
                        <img class="2" :src="preview" />
                      </div>
                      <v-file-input
                        accept="image/*"
                        v-model="imgShop"
                        @change="onFileChange"
                        ref="imgShop"
                        name="imgShop"
                        label="Logo de la tienda"
                      ></v-file-input>
                      <v-select
                        ref="category"
                        v-model="datos.category"
                        :items="itemsCategories"
                        :rules="[(v) => !!v || 'La categoria es requerida']"
                        label="Categoria"
                        required
                      ></v-select>
                      <v-text-field
                        ref="celContact"
                        v-model="datos.celContact"
                        :rules="inputRules"
                        label="Celular de contacto"
                        required
                      ></v-text-field>

                      <v-select
                        ref="activate"
                        v-model="datos.activate"
                        item-value="id"
                        item-text="name"
                        :items="itemsActive"
                        label="itemsActive"
                      ></v-select>
                    </v-col>
                    <v-col cols="12">
                      <v-select
                        ref="country"
                        v-model="datos.country"
                        :items="itemsContry"
                        :rules="[(v) => !!v || 'El pais es requerido']"
                        label="País"
                        required
                      ></v-select>
                      <v-text-field
                        ref="mailSuport"
                        v-model="datos.mailSuport"
                        :rules="emailRules"
                        label="Correo Electronico de soporte"
                        required
                      ></v-text-field>
                      <v-text-field
                        ref="urlname"
                        :value="datos.urlName"
                        label="url de la tienda"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-tab-item>
            <v-tab-item :key="2">
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-select
                      ref="systemPays"
                      v-model="datos.systemPays"
                      :items="itemsPays"
                      item-value="name"
                      item-text="name"
                      :rules="[(v) => !!v || 'el sistema de pago es requerido']"
                      label="Plataforma de pago"
                      required
                    ></v-select>
                    <v-text-field
                      ref="PayuMerchantId"
                      v-model="datos.PayuMerchantId"
                      :rules="inputRules"
                      label="merchantId"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-text-field
                      ref="PayuAccountId"
                      v-model="datos.PayuAccountId"
                      :rules="inputRules"
                      label="accountId"
                      required
                    ></v-text-field>
                    <v-text-field
                      ref="PayuApiKey"
                      v-model="datos.PayuApiKey"
                      :rules="inputRules"
                      label="ApiKey"
                      required
                    ></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6" md="6"> </v-col>
                </v-row>
              </v-container>
            </v-tab-item>
            <v-tab-item :key="3">
              <v-card class="tab_tall" flat>
                <v-card-text>
                  <p class="subhead">Agregue los datos de transporte</p>
                  <v-row>
                    <v-col cols="5">
                      <div class="divbox_add">
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              ref="cityTransport"
                              v-model="cityTransport"
                              label="Ciudad"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              ref="valTrasport"
                              type="number"
                              v-model="valTrasport"
                              :rules="priceRules"
                              label="Valor del transporte"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <div class="cent-add">
                              <v-btn @click="addTransport" large>Agregar</v-btn>
                            </div>
                          </v-col>
                        </v-row>
                      </div>
                    </v-col>
                    <v-col cols="7">
                      <p>Listado de tarifa de transporte</p>
                      <div
                        class="cl_stock"
                        v-for="item in datos.transport"
                        :key="item.id"
                      >
                        <div class="cl_item">
                          <span>
                            <b>{{ item.cityTransport }}</b>
                          </span>
                        </div>
                        <div class="cl_item">
                          <span>{{ item.valTrasport | currency }}</span>
                        </div>
                        <v-btn
                          class="cl_close"
                          icon
                          @click="delTransport(item)"
                        >
                          <span class="material-icons">close</span>
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div class="ctn_btn_shop">
              <v-btn large text @click.stop="show = false">Cerrar</v-btn>
              <v-btn
                :disabled="!valid"
                depressed
                large
                color="primary"
                @click="validate"
                >GUARDAR</v-btn
              >
            </div>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from 'axios';
import { mapGetters, mapActions } from 'vuex';
import urlBaseApi from '../../plugins/urlBase.js';
//import AlertMsj from '@/components/dashboard/AlertMsj.vue';

export default {
  name: 'EditShop',
  props: ['visible', 'datos'],
  data() {
    return {
      tab: null,
      urlBaseApi: urlBaseApi,
      userID: null,
      itemsCategories: null,
      cityTransport: null,
      valTrasport: 1,
      itemsContry: ['Colombia', 'Argentina'],
      itemsPays: [{ id: 0, name: 'Payu' }],
      preview: null,
      imgShop: null,
      itemsActive: [
        { id: 0, name: 'offline' },
        { id: 1, name: 'online' },
      ],
      inputRules: [(v) => !!v || 'El campo es requerido'],
      nameRules: [(v) => !!v || 'El nombre es requerido'],
      emailRules: [
        (v) =>
          !v ||
          /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(v) ||
          'El formato no es valido',
      ],
      valid: true,
    };
  },
  mounted() {
    this.categoryShop();
    this.userID = this.userId;
    this.itemsCategories = this.getCateShop;
  },

  methods: {
    ...mapActions(['listShops', 'updateShop', 'categoryShop', 'alertGeneral']),

    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm();
      }
    },
    addTransport() {
      let obj = {
        cityTransport: this.cityTransport,
        valTrasport: this.valTrasport,
      };
      if (
        this.cityTransport != null &&
        this.valTrasport != null &&
        this.cityTransport != '' &&
        this.valTrasport != ''
      ) {
        this.datos.transport.push(obj);
        this.cityTransport = null;
        this.valTrasport = 1;
      } else {
        //console.log('error');
      }
    },
    delTransport(item) {
      let i = this.datos.transport.indexOf(item);
      this.datos.transport.splice(i, 1);
    },
    onFileChange(e) {
      if (this.imgShop != null) {
        const file = e;
        //console.log('obj', e);
        //console.log("obj", file);
        this.preview = URL.createObjectURL(file);
      } else {
        this.preview = null;
      }
    },
    registerForm() {
      try {
        const formData = new FormData();
        formData.append('_id', this.datos._id);
        formData.append('name_shop', this.datos.name_shop);
        formData.append('user', this.datos.user);
        formData.append('address', this.datos.address);
        if (this.imgShop != null) {
          formData.append('imgShop', this.imgShop);
        }
        formData.append('transport', JSON.stringify(this.datos.transport));
        formData.append('systemPays', this.datos.systemPays);
        formData.append('PayuMerchantId', this.datos.PayuMerchantId);
        formData.append('PayuApiKey', this.datos.PayuApiKey);
        formData.append('PayuAccountId', this.datos.PayuAccountId);

        formData.append('numContact', this.datos.numContact);
        formData.append('instagram', this.datos.instagram);
        formData.append('celContact', this.datos.celContact);
        formData.append('face', this.datos.face);
        formData.append('activate', this.datos.activate);
        formData.append('mailSuport', this.datos.mailSuport);
        formData.append('category', this.datos.category);
        formData.append('country', this.datos.country);
        // call store api
        //console.log('data send', formData);
        this.updateShop(formData);
        // close modal
        // reset form
        this.$refs.form.reset();
        this.imgShop = null;
        // update table shop
        this.alertGeneral({
          flat: true,
          msj: 'La tienda se ha editado correctamente.',
        });
        this.show = false;
      } catch (error) {
        this.alertGeneral({
          flat: true,
          msj: '¡Huy! Ocurrió un error, inténtelo más tarde.',
        });
        this.errmensaje = 'Ops! ocurrio un error con el servidor';
      }
    },
  },
  computed: {
    ...mapGetters(['userId', 'getCateShop']),
    isActive() {
      return this.valid;
    },

    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit('close');
        }
      },
    },
  },
};
</script>

<style lang="scss">
.preview_img {
  width: 100%;
  height: 128px;
  padding: 5px;
  margin-bottom: 15px;
  img {
    max-width: 100%;
    width: 100%;
    height: 128px;
    object-fit: contain;
  }
}
span.headl {
  font-family: 'Roboto Condensed', sans-serif !important;
  font-size: 1.5rem !important;
}
.ctn_btn_shop {
  button.v-btn {
    min-width: 120px !important;
  }
}
</style>
